module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-25.9078bddf.png";